import React, { useState } from "react";
import "./NewsLetter.css";
import EmailBuilder from "./EmailBuilder";
import CampaignStats from "./CampaignStats";
import Button from "../../components/Button/Button";

export default function NewsLetter() {
    const [activeSection, setActiveSection] = useState("nueva");

    return (
        <article className="container-home container-newsletter-page">
            <h1 className="title">
                NEWSLETTER
                <hr />
            </h1>

            <div className="nl-submenu" role="tablist" aria-label="Submenu de newsletter">
                <Button
                    type="button"
                    variant="outline"
                    size="small"
                    role="tab"
                    className="nl-submenu-btn"
                    selected={activeSection === "nueva"}
                    aria-selected={activeSection === "nueva"}
                    onClick={() => setActiveSection("nueva")}
                >
                    Crear nueva campaña
                </Button>
                <Button
                    type="button"
                    variant="outline"
                    size="small"
                    role="tab"
                    className="nl-submenu-btn"
                    selected={activeSection === "metricas"}
                    aria-selected={activeSection === "metricas"}
                    onClick={() => setActiveSection("metricas")}
                >
                    Métricas por campaña
                </Button>
            </div>

            {activeSection === "nueva" ? <EmailBuilder /> : <CampaignStats />}
        </article>
    );
}
